module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/Lifestyle-icon-d91cb8c719b881c44eceaf3b1d96ed1f.png";